export enum ConstructionStage {
    None = 0,
    Configured = 1,
    RTC = 2,
    Start = 3,
    Frame = 4,
    Second = 5,
    Final = 6
}
